import { Link } from "react-router-dom";
import { setting } from "../Config/Config";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2 style={{ color: setting.blue }}>Our Services</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 ser">
                  <div class="icon-box-img">
                    <img src={d.image} title="01-2.png" alt="01-2.png" />
                  </div>
                  <div className="service-desc">
                    <h3>
                      <Link to={d.link} style={{ color: setting.orange }}>
                        {d.name}
                      </Link>
                    </h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
